import { useNavigate } from 'react-router-dom';

import { t } from '../i18n/t';
import { confirmLeave, useLiveSession } from '../session/live';

/**
 * A click handler for a link out of the shell, shared by the bottom nav and
 * the header's account link so neither can leave a live conversation without
 * asking.
 *
 * Confirming ends the conversation and stays put rather than following the
 * link: ending and navigating in the same tick unmounted the conversation
 * screen before it could show the one thing a finished session exists to
 * show -- the stars in the kid register, the debrief in the adult one. A
 * child who taps Home to finish should not be the only one who never sees how
 * they did; the link is one tap away, and the second tap goes straight
 * through because the session is no longer live.
 */
export function useGuardedGo() {
  const navigate = useNavigate();
  const { live, end } = useLiveSession();
  return (to: string) => (e: React.MouseEvent) => {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    e.preventDefault();
    if (!confirmLeave(live, () => window.confirm(t('nav-confirm-leave')))) return;
    if (live) {
      void end();
      return;
    }
    void navigate(to);
  };
}
